import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from 'firebase/auth';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDrNkeB0hldDq0diuR5OADD-NgXp1kETig",
  authDomain: "the-sattva-tech.firebaseapp.com",
  projectId: "the-sattva-tech",
  storageBucket: "the-sattva-tech.firebasestorage.app",
  messagingSenderId: "192891314975",
  appId: "1:192891314975:web:cad7bb6c4db5ea5fd5862a",
  measurementId: "G-V77LSX5Y8Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
export const storage = getStorage(app)
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const BLOG_DOC_NAME = 'blogsTest';
export const JOB_DOC_NAME = 'jobs';
export default app